import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import slider1 from '../assets/slider1.jpg';
import slider2 from '../assets/slider2.jpg';
import slider3 from '../assets/slider3.jpg';
import slider4 from '../assets/slider4.jpg';

const SliderWrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

const Slide = styled.div<{ active: boolean; bgImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${props => props.active ? 1 : 0};
  transition: opacity 1s ease-in-out;
  
  /* Imagen de fondo directamente en el estilo */
  background-image: url(${props => props.bgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  /* Overlay oscuro */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 10;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 5%;
  max-width: 1200px;
  
  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`;

const Title = styled.h1`
  font-size: 4rem;
  color: var(--white);
  font-family: 'Adilezy', 'Darker Grotesque', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif;
  font-weight: 300;
  font-synthesis-weight: none;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.8);
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.5rem;
  color: var(--white);
  font-family: 'Adilezy', 'Darker Grotesque', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif;
  font-weight: 300;
  font-synthesis-weight: none;
  margin-bottom: 2rem;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.8);
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Button = styled.button`
  background: var(--primary-turquoise);
  color: var(--navy-blue);
  border: none;
  padding: 15px 40px;
  font-size: 1.2rem;
  font-family: 'Roboto', 'Darker Grotesque', system-ui, -apple-system, 'Segoe UI', Arial, sans-serif;
  font-weight: 500;
  border-radius: 50px;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 2px;
  transition: all 0.3s ease;
  
  &:hover {
    background: var(--dark-turquoise);
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(58, 174, 171, 0.35);
  }
`;

const Dots = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 20;
`;

const Dot = styled.button<{ active: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background: ${props => props.active ? 'var(--brand-gold)' : 'rgba(227, 227, 221, 0.55)'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: var(--brand-gold);
  }
`;

const slides = [
  {
    id: 1,
    title: "¡Bienvenidos a Pepe Tiburón!",
    subtitle: "Los mejores mariscos de Arequipa",
    image: slider1
  },
  {
    id: 2,
    title: "Ceviche Fresco",
    subtitle: "Preparado con pescado del día",
    image: slider2
  },
  {
    id: 3,
    title: "Sabor Tradicional",
    subtitle: "Recetas de familia desde 1990",
    image: slider3
  },
  {
    id: 4,
    title: "Sabor del Mar",
    subtitle: "Vive la experiencia marina más cerca de ti",
    image: slider4
  }
];

const SimpleSlider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  const handleCartaClick = () => {
    const menuSection = document.getElementById('menu-catalog');
    if (menuSection) {
      menuSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <SliderWrapper id="inicio">
      {slides.map((slide, index) => (
        <Slide 
          key={slide.id} 
          active={index === currentSlide}
          bgImage={slide.image}
        >
          <Content>
            <Title>{slide.title}</Title>
            <Subtitle>{slide.subtitle}</Subtitle>
            <Button onClick={handleCartaClick}>
              VER CARTA
            </Button>
          </Content>
        </Slide>
      ))}
      
      <Dots>
        {slides.map((_, index) => (
          <Dot
            key={index}
            active={index === currentSlide}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </Dots>
    </SliderWrapper>
  );
};

export default SimpleSlider;